var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"228.3,49 104.1,173.2 55.1,124.3 24.4,155 104.1,234.5 259.1,79.5 "}));
}

Check.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = Check;

Check.default = Check;
